import {useStore} from "vuex";
import {computed} from "vue";

export default function useMessages() {
  const store = useStore()

  return {
    messagesList: computed(() => store.state.messages.messagesList)
  }
}
